import { FloatingMenuProps, Typeahead } from "@zapier/design-system";
import { Zap, zapsSearchAsyncAtomFamily } from "@zapier/canvas-state";
import { useMemo, useState } from "react";
import { useAtomValue } from "jotai";
import { Loadable } from "jotai/vanilla/utils/loadable";
import { useDebouncedValue } from "../../../hooks/useDebouncedValue";

type Props = {
  floatingMenuProps?: Partial<FloatingMenuProps>;
  id?: string;
  onChange: (zap: Zap) => void;
  selectedZap: Zap;
};

type InputProps = {
  id: string;
  isDisabled: boolean;
  isErrored: boolean;
};

function ZapFilter(props: Props & InputProps) {
  const { id, isDisabled, isErrored, onChange } = props;
  const [searchTerm, setSearchTerm] = useState<string>("");
  const debouncedSearchTerm = useDebouncedValue(searchTerm, 300);

  const zapsLoadable = useAtomValue(
    zapsSearchAsyncAtomFamily({ searchTerm: debouncedSearchTerm }),
  ) as Loadable<Zap[]>;
  const isLoading = zapsLoadable.state === "loading";
  const hasData = zapsLoadable.state === "hasData";
  const zaps = useMemo(
    () => (hasData ? zapsLoadable.data : []),
    [hasData, zapsLoadable],
  );

  return (
    <Typeahead
      aria-label="Search Zaps"
      autoComplete="off"
      getLabelForItem={(item: Zap) => item.title || "Untitled Zap"}
      id={id}
      inputId={props.id}
      isBusy={isLoading}
      isDisabled={isDisabled}
      isErrored={isErrored}
      items={zaps}
      menuAriaLabel="list of zaps"
      onChange={onChange}
      onInputValueChange={setSearchTerm}
      placeholder="Search my Zaps"
      showErrorOnNoResults={false}
      size="small"
      selectedItem={props.selectedZap}
      openOnFocus={true}
    />
  );
}

export default ZapFilter;
